// src/services/email/emailServices.js
import axios from 'axios';
import { API } from '../../backend';
import authHeader from '../auth-header';

const BASE = `${API}email_formator/`;

const EmailTemplateService = {
  // 1. Variables
  getVariables: () => axios.get(`${BASE}variables/`, { headers: authHeader() }),

  // 2. Templates CRUD
  getTemplates: (category) =>
    axios.get(`${BASE}templates/`, {
      params: category ? { category } : {},
      headers: authHeader(),
    }),

  getTemplate: (name) =>
    axios.get(`${BASE}templates/${name}/`, { headers: authHeader() }),

  createTemplate: (data) =>
    axios.post(`${BASE}templates/`, data, { headers: authHeader() }),

  updateTemplate: (name, data) =>
    axios.put(`${BASE}templates/${name}/`, data, { headers: authHeader() }),

  // 3. Company Override
  getCompanyOverride: (name) =>
    axios.get(`${BASE}templates/${name}/company/`, { headers: authHeader() }),

  updateCompanyOverride: (name, data) =>
    axios.put(`${BASE}templates/${name}/company/`, data, { headers: authHeader() }),

  deleteCompanyOverride: (name) =>
    axios.delete(`${BASE}templates/${name}/company/`, { headers: authHeader() }),

  // 4. Preview
  previewTemplate: (name, context = {}) =>
    axios.post(`${BASE}templates/${name}/company/preview/`, { context }, { headers: authHeader() }),

  // 5. Send Test Email
  sendTestEmail: (name, payload) =>
    axios.post(`${BASE}templates/${name}/send/`, payload, { headers: authHeader() }),

  // 6. Status Active / Inactive
  activateTemplate(id) {
    return axios.post(`${BASE}templates/activate/${id}/`, {}, { headers: authHeader() });
  },

  inactivateTemplate(id) {
    return axios.post(`${BASE}templates/inactivate/${id}/`, {}, { headers: authHeader() });
  },


};

export default EmailTemplateService;